<template>
  <el-form label-position="left" ref="baseinfo" label-width="80px" :model="userInfo" size="small" style="width: 360px">
    <el-form-item label="原密码:" required>
      <el-input v-model="userInfo.oldPwd" placeholder="请输入原密码" show-password></el-input>
    </el-form-item>
    <el-form-item label="新密码:" required>
      <el-input v-model="userInfo.newPwd" placeholder="请输入新密码" show-password></el-input>
    </el-form-item>
    <el-form-item label="确认密码:" required>
      <el-input v-model="userInfo.surePassword" placeholder="请再次输入新密码" show-password></el-input>
    </el-form-item>
    <el-button type="primary" style="width: 128px;margin-top: 0px" @click="onSubmit">保存</el-button>
  </el-form>
</template>
<script>
  import { Encrypt } from '@/utils/crypto'
  import { getToken, setToken, removeToken } from '@/utils/auth'

export default {
   data() {
    const validateOri = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入原密码！'))
      } else {
        callback()
      }
    }
    const validateNew = (rule, value, callback) => {
      if (!validEmail(value)) {
        callback(new Error('请输入新密码！'))
      } else {
        callback()
      }
    }
    const validateRep = (rule, value, callback) => {
      if (!validMobile(value)) {
        callback(new Error('请确认两次输入密码一致！'))
      } else {
        callback()
      }
    }
    return {
      userInfo: {
        oldPwd: '',
        newPwd: '',
        surePassword: '',
        repeatPassword: ''
      },
      userRules: {
        oriPassword: [{ required: true, trigger: 'blur', validator: validateOri }],
        newPassword: [{ required: true, trigger: 'blur', validator: validateNew }],
        repeatPassword: [{ required: true, trigger: 'blur', validator: validateRep }]
      },
      isEdit: false
    };
  },
  methods: {
    loseFocus() {
      this.isEdit = !this.isEdit
    },
    onSubmit() {
      // this.$refs.baseinfo.validate(valid => {
      // })
      let resex2 = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{8,20}$/;

      if (!this.userInfo.oldPwd || !this.userInfo.newPwd || !this.userInfo.surePassword) {
        this.$message.error('必填字段不能为空!')
        return false
      }

      // if (!resex2.test(this.userInfo.oldPwd) || !resex2.test(this.userInfo.newPwd)) {
      //   this.$message.error('密码需包含写字母特殊符号数字且不少于8位!')
      //   return false
      // }
      if (this.userInfo.surePassword != this.userInfo.newPwd) {
        this.$message.error('两次输入密码须一致!')
        return false
      }
      // if (this.userInfo.oldPwd == this.userInfo.newPwd || this.userInfo.oldPwd == this.userInfo.surePassword ) {
      //   this.$message.error('原密码和新密码不能相同!')
      //   return false
      // }

      this.$api.personUpdatePassword({
        newPassword: Encrypt(this.userInfo.newPwd),
        oldPassword: Encrypt(this.userInfo.oldPwd),
      }).then(res => {
        let code = res.errcode
        if (code == 0) {
          this.$store.dispatch('user/logout').then((res)=>{
            this.$message.success(res.errmsg)
            this.userInfo = {}
          }).catch(()=>{})
          this.$emit("success");
        }
      })
    }
  },
  created() {
  }
}
</script>
<style scoped>

</style>